import React from 'react';
import { Box, BoxProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { animationTransition } from '@shared/utils/animationTransition';
import { CTAButton } from './CTAButton';

interface HoverTileOverlayProps extends Omit<BoxProps, 'children'> {
  ctaTitle: string;
  borderRadius?: string;
}

export const HoverTileOverlay: React.FC<HoverTileOverlayProps> = ({ ctaTitle, borderRadius = pxToRem(36), ...boxProps }) => {
  return (
    <Box
      position="absolute"
      top="calc(100% - 1px)"
      left={0}
      right={0}
      display="none"
      css={{
        '.group:hover &': {
          display: 'block'
        }
      }}
      zIndex={10}
      backgroundColor="white"
      paddingX={6}
      paddingTop={1}
      paddingBottom={6}
      borderBottomLeftRadius={borderRadius}
      borderBottomRightRadius={borderRadius}
      boxShadow="0px 7px 20px -8px rgba(44, 41, 37, 0.06), -4px 10px 16px -6px rgba(0, 0, 0, 0.07), 4px 10px 16px -6px rgba(0, 0, 0, 0.07)"
      transition={animationTransition('box-shadow', {
        duration: '300ms'
      })}
      {...boxProps}
    >
      <CTAButton ctaTitle={ctaTitle} width="100%" />
    </Box>
  );
};

HoverTileOverlay.displayName = 'HoverTileOverlay';
